export const LANGUAGES = ["en", "fr", "keys"] as const;
export type Language = (typeof LANGUAGES)[number];
